export default __webpack_public_path__ + "static/prepaid-card-retail-revolution-aef0e726ac377fdd44781f2d949b2c63.png";